import { IAreaOccupancyStats, IShiftOccupancyStats } from '@localina/core';
import React from 'react';
import { RestaurantStatsTimeGrid } from '../RestaurantStatsTimeAxis';
import { getLanes, getShiftRange, ITimeRange } from '../RestaurantStatsTimeline';
import { RestaurantStatsAreaTile } from './index';

interface IProps {
    stats: IAreaOccupancyStats;
    date: string;
    range: ITimeRange;
}

const toPercent = (average: number) => Math.round(average * 100);

// One area's shifts on the day's time axis; shifts that overlap stack in extra lanes.
export const RestaurantStatsShiftTile: React.FC<IProps> = (props) => {
    const lanes = getLanes(props.stats.shiftOccupancyStats, (it) => getShiftRange(it.shift));
    // The average is labelled once, on the leftmost shift; a later shift only repeats it if its value differs.
    const firstShift = lanes[0]?.[0];
    const showAverageLabel = (it: IShiftOccupancyStats) =>
        it === firstShift || toPercent(it.stats.average) !== toPercent(firstShift?.stats.average ?? 0);

    return (
        <div className="restaurant-stats__track">
            <RestaurantStatsTimeGrid range={props.range} />
            {lanes.map((lane, index) => (
                <div key={index} className="restaurant-stats__track__lane">
                    {lane.map((it) => (
                        <RestaurantStatsAreaTile
                            key={it.shift.id}
                            stats={it}
                            date={props.date}
                            area={props.stats.area}
                            range={props.range}
                            showAverageLabel={showAverageLabel(it)}
                        />
                    ))}
                </div>
            ))}
        </div>
    );
};
